export default search => {
  const end = search.indexOf(`/`)
  return end > -1 ? search.slice(0, end) : search
}
